import { getBackendApiPort, getPokerRoomAlias } from '../constants';
import { isProduction } from '../utils/production.utils';

export const backendApiUrl = isProduction()
  ? `https://${getPokerRoomAlias().toLowerCase()}.hammerfell-bs.com/api`
  : `http://localhost:${getBackendApiPort()}`;

export const websocketUrl = `${backendApiUrl}/ws-hammer-fell`;
